import { Container } from "reactstrap";
import { NavLink} from "react-router-dom"
import "../Navbar/Navbar.css";


import React, {  useRef} from 'react'

const NavLinks= [
    {/*
        path:'/sidebar',
        display: <i class="ri-menu-line"></i>
*/},
    {
        path:'/home',
        display: 'La Hoja Cortada'
    },
    {
        path:'/contact',
        display: 'Contacto'
    },
    {
        path:'/gallery',
        display: 'Galería'
    }
]






const Navbar = () => {

    const menuRef = useRef (null)

    const toggleMenu = ()=> menuRef.current.classList.toggle('menu__active')

return (
    <div className="main__navbar">
        <Container>
            <div className="navigation__wrapper d-flex align-items-center justify-content-between">
                <span className="mobile__menu">
                <i class="ri-menu-line" onClick={toggleMenu}></i>
                </span>
                <div className="navigation" ref={menuRef} onClick={toggleMenu}>
                    <div className="menu"> 
                        {
                        NavLinks.map ((item, index)=>(
                    <NavLink to={item.path} className={navClass=>navClass.isActive ? 'nav__active nav__item' : 'nav__item'} key= {index} >  {item.display}
                    </NavLink> ))
                        }
                    </div>
                </div> 

                <div className="nav__right">
                    <div className="search__box">
                        <input type="text" placeholder="Buscar"/>
                        <span><i class="ri-search-line"></i></span>
                    </div>
                </div>

            </div>
        </Container>
    </div>
)
}

export default Navbar



